<template>
  <div class="external-footer">
    <div class="row">
      <div class="column column-100" v-if="page === 'form'">
        You can also support us with <a href="/crypto_en" target="_blank">Crypto</a>. You can <span @click="changePage('unsubscribe')">unsubscribe</span> or <span @click="changePage('changeSubscription')">change subscription</span> anytime, just send us a request with your e-mail. With any problem please contact us <a href="email:donate@ovdinfo.org">donate@ovdinfo.org</a>
      </div>
      <div class="column column-100" v-else>
        <span @click="changePage('form')">← Donation</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    page: state => state.page,
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  methods: {
    changePage: function (page) {
      this.$store.dispatch('showPage', page)
    }
  }
}
</script>

<style scoped>
  .external-footer {
    font-family: CoFo Sans;
    font-size: 15px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    color: #ABBCC1;
  }

  .external-footer a,
  .external-footer span {
    text-decoration: underline;
    color: #FF6F37!important;
    cursor: pointer;
  }
</style>
